import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination, Scrollbar, Keyboard, Mousewheel } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';

/** Page builder Carousel component */
new Swiper('.swiper-carousel.swiper-carousel-images', {
    modules: [Autoplay, Navigation, Pagination, Scrollbar],
    loop: true,
    pagination: { el: '.swiper-pagination', clickable: true },
    navigation: { prevEl: '.swiper-button-prev', nextEl: '.swiper-button-next' },
});

/** Program days carousel */
let daysSwiper = null;
let selectedDay = null;

const initProgramDaysSelectorCarousel = (day = null) => {
    const containerSel = '#days-swiper-container';
    const swiperSel = '#days-swiper';
    const prevSel = `${containerSel} #days-prev`;
    const nextSel = `${containerSel} #days-next`;

    const el = document.querySelector(containerSel);
    const swiperEl = document.querySelector(swiperSel);
    if (!el || !swiperEl) return;

    const nextDay = day || el.dataset.selectedDay;

    if (!selectedDay || (selectedDay !== nextDay)) {
        selectedDay = nextDay;

        const slides = Array.from(swiperEl.querySelectorAll('.swiper-slide'));
        let startIndex = slides.findIndex(s => s.dataset.date === selectedDay);
        if (startIndex < 0) {
            startIndex = Math.max(0, slides.findIndex(s => s.classList.contains('swiper-slide-active')));
        }

        if (daysSwiper?.destroy) daysSwiper.destroy(true, true);

        const prevBtn = el.querySelector('#days-prev');
        const nextBtn = el.querySelector('#days-next');

        const updateNav = (sw) => {
            const toggle = (btn, disabled) => {
                if (!btn) return;
                btn.toggleAttribute('disabled', disabled);
                btn.classList.toggle('swiper-button-disabled', disabled);
                btn.setAttribute('aria-disabled', String(disabled));
            };
            toggle(prevBtn, sw.isBeginning);
            toggle(nextBtn, sw.isEnd);
        };

        swiperEl.setAttribute('tabindex', '0');
        swiperEl.setAttribute('aria-roledescription', 'carousel');

        daysSwiper = new Swiper(swiperSel, {
            modules: [Navigation, Pagination, Scrollbar, Keyboard, Mousewheel],
            slidesPerView: 1,
            centeredSlides: true,
            spaceBetween: 8,
            initialSlide: startIndex,
            watchOverflow: true,

            navigation: {
                prevEl: prevSel,
                nextEl: nextSel
            },

            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                dynamicBullets: true,
            },

            keyboard: {
                enabled: true,
                onlyInViewport: true,
                pageUpDown: true
            },

            mousewheel: {
                enabled: true,
                forceToAxis: true,
                releaseOnEdges: true,
                thresholdDelta: 10,
                eventsTarget: containerSel
            },

            on: {
                init(sw) { updateNav(sw); },
                slideChange(sw) {
                    updateNav(sw);
                    const active = sw.slides[sw.activeIndex];
                    const day = active?.dataset?.date;
                    Livewire.dispatch('toggle-active-day', { day });
                },
                resize(sw) { updateNav(sw); },
            }
        });
    }
};

document.addEventListener('DOMContentLoaded', () => {
    initProgramDaysSelectorCarousel();
    window.addEventListener('resize', () => daysSwiper?.update());
});

Livewire.on('program-reset-days-selector', (e) => {
    setTimeout(function () {
        initProgramDaysSelectorCarousel(e.day);
    }, 100);
});
